module.exports = __webpack_public_path__ + "static/media/logo-white.3f625bd3.png";